// extracted by mini-css-extract-plugin
module.exports = {"wrapperPictures":"index_wrapperPictures__36DDW","uploadPictureButton":"index_uploadPictureButton__2gA6F","iconDelete":"index_iconDelete__2plf5"};